'use client';

import {
	Dialog,
	DialogBackdrop,
	DialogPanel,
	DialogTitle,
} from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';

import type { SystemNotificationV1 } from '@/shared/api';
import {
	Carousel,
	CarouselContent,
	CarouselIndicator,
	CarouselItem,
} from '@/shared/ui/carousel';

import { AlertContent } from './alert-content';
import { CarouselNavigationButtons } from './carousel-navigation-buttons';

interface SystemAlertModalProps {
	alerts: SystemNotificationV1[];
	isOpen: boolean;
	onClose: () => void;
}

export const SystemAlertModal = ({
	alerts,
	isOpen,
	onClose,
}: SystemAlertModalProps) => {
	return (
		<Dialog open={isOpen} onClose={onClose} className="relative z-50">
			<DialogBackdrop className="fixed inset-0 bg-gray-1/60 backdrop-blur-[1px]" />
			<div className="fixed inset-0 flex w-screen items-end justify-center sm:items-center sm:p-4">
				<DialogPanel className="bg-white-main relative w-full bg-white sm:max-w-[600px] sm:rounded-lg sm:border sm:border-gray-4">
					<div className="border-gray flex flex-row items-center justify-between gap-2 border-b px-4 py-6">
						<DialogTitle className="text-xl font-bold">
							Важная информация
						</DialogTitle>
						<button
							type="button"
							onClick={onClose}
							className="text-gray-3 hover:text-gray-2"
						>
							<XMarkIcon className="size-6" />
						</button>
					</div>
					<div className="py-4">
						{alerts.length === 1 ? (
							<div className="px-4">
								<AlertContent alert={alerts[0]} />
							</div>
						) : (
							<Carousel initialIndex={0}>
								<CarouselContent>
									{alerts.map((alert, index) => (
										<CarouselItem key={index} className="px-4">
											<AlertContent alert={alert} />
										</CarouselItem>
									))}
								</CarouselContent>
								<CarouselIndicator classNameButton="mb-2 md:mb-4" />
								<CarouselNavigationButtons />
							</Carousel>
						)}
					</div>
				</DialogPanel>
			</div>
		</Dialog>
	);
};
